import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiEndPoint } from "../../app.component";
import { User } from "../models/users";

@Injectable({
  providedIn: "root",
})
export class UserService {
  authToken: string = ApiEndPoint + "auth/token/";
  base: string = ApiEndPoint + "users/";
  info: string = this.base + "info/";
  list: string = this.base + "list/";
  create: string = this.base + "create/";
  update: string = this.base + "edit/";
  resetPass: string = this.base + "resetPaswd/";

  constructor(private http: HttpClient) {}

  listUsers() {
    return this.http.get<User[]>(this.list);
  }
  getInfo() {
    return this.http.get<User[]>(this.info);
  }
  changePassword(data) {
    return this.http.post(this.base + "changPaswd/", data);
  }
  getAuth(data: User) {
    return this.http.post(this.base + "getAuth/", {
      username: data.auth_username,
      fullname: data.fullname,
    });
  }
  updateUser(data: User) {
    return this.http.post(this.update, {
      id: data.auth,
      username: data.auth_username,
      fullname: data.fullname,
      active: data.auth_is_active,
      branch: data.branch,
      barnchEmployees: data.barnchEmployees,
    });
  }

  createUser(data: User) {
    return this.http.post(this.create, data);
  }

  updateUserFinal(data: User) {
    return this.http.put(this.base + "editUsr/" + data.id + "/", data);
  }

  resetPassword(id: number) {
    return this.http.post(this.resetPass, id);
  }

  disableUsr(data: User) {
    return this.http.put(this.base + "editUsr/" + data.id + "/", data);
  }
  listBranches() {
    return this.http.get(`${this.base}branch/list/`);
  }
  createBranch(data) {
    return this.http.post(`${this.base}branch/create/`, data);
  }
  updateBranch(data) {
    return this.http.put(`${this.base}branch/edit/${data.id}/`, data);
  }
  deleteBranch(id: number) {
    return this.http.delete(`${this.base}branch/edit/${id}/`);
  }
}
